import React from "react";

export const ArrowRight = ({
  width = "31.631",
  height = "20.334",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 31.631 20.334"
    >
      <path
        id="vector_Stroke_"
        data-name="vector (Stroke)"
        d="M20.54.6a2.259,2.259,0,0,1,3.193.128l7.3,7.908a2.259,2.259,0,0,1,0,3.065l-7.3,7.908a2.259,2.259,0,1,1-3.32-3.065l3.8-4.116H2.259a2.259,2.259,0,0,1,0-4.519H24.211l-3.8-4.116A2.259,2.259,0,0,1,20.54.6Z"
        transform="translate(0)"
        fill={color}
      />
    </svg>
  );
};

export const KwikCashIcon = ({
  width = "22.216",
  height = "18.748",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22.216 18.748"
    >
      <g id="Group_161704" data-name="Group 161704" transform="translate(0 0)">
        <path
          id="Path_16323"
          data-name="Path 16323"
          d="M1035.51,288.349c-6.125,0-11.108,4.205-11.108,9.374s4.983,9.374,11.108,9.374,11.108-4.205,11.108-9.374S1041.635,288.349,1035.51,288.349Zm0,17.278c-5.165,0-9.367-3.546-9.367-7.9s4.2-7.9,9.367-7.9,9.367,3.546,9.367,7.9S1040.675,305.627,1035.51,305.627Z"
          transform="translate(-1024.402 -288.349)"
          fill={color}
        />
        <path
          id="Path_16324"
          data-name="Path 16324"
          d="M1121.678,367.211h-2.744l-2.571,3.071v1.024l2.629,3.1h2.831l-3.293-3.6Z"
          transform="translate(-1108.367 -361.432)"
          fill={color}
        />
        <path
          id="Path_16325"
          data-name="Path 16325"
          d="M1168.516,370.806l3.148-3.6h-2.744l-2.571,3.071v1.024l2.629,3.1h2.831Z"
          transform="translate(-1154.008 -361.432)"
          fill={color}
        />
        <rect
          id="Rectangle_4110"
          data-name="Rectangle 4110"
          width="2.201"
          height="7.191"
          transform="translate(5.116 5.779)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const KwikCash = ({
  width = "17.447",
  height = "14.275",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17.447 14.275"
    >
      <g
        id="icons_Credit_Card_Line"
        data-name="icons/Credit Card/Line"
        transform="translate(-0.667 -2)"
      >
        <path
          id="Shape"
          d="M15.068,1.586H2.379a.793.793,0,0,0-.793.793V11.9a.793.793,0,0,0,.793.793H15.068a.793.793,0,0,0,.793-.793V2.379A.793.793,0,0,0,15.068,1.586ZM2.379,0A2.379,2.379,0,0,0,0,2.379V11.9a2.379,2.379,0,0,0,2.379,2.379H15.068A2.379,2.379,0,0,0,17.447,11.9V2.379A2.379,2.379,0,0,0,15.068,0Z"
          transform="translate(0.667 2)"
          fill={color}
          fill-rule="evenodd"
        />
        <path
          id="Shape-2"
          data-name="Shape"
          d="M2.379,1.19A1.19,1.19,0,1,1,1.19,0,1.19,1.19,0,0,1,2.379,1.19Z"
          transform="translate(3.839 10.724)"
          fill={color}
        />
        <path
          id="Shape-3"
          data-name="Shape"
          d="M2.379,1.19A1.19,1.19,0,1,1,1.19,0,1.19,1.19,0,0,1,2.379,1.19Z"
          transform="translate(7.804 10.724)"
          fill={color}
        />
        <path
          id="Shape-4"
          data-name="Shape"
          d="M0,0H17.447V1.586H0Z"
          transform="translate(0.667 5.965)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const Plus = ({
  width = "12.917",
  height = "12.917",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12.917 12.917"
    >
      <path
        id="plus"
        d="M12.128,18.585v-4.11H8.018a1.174,1.174,0,1,1,0-2.349h4.11V8.017a1.174,1.174,0,0,1,2.349,0v4.11h4.11a1.174,1.174,0,1,1,0,2.349h-4.11v4.11a1.174,1.174,0,0,1-2.349,0Z"
        transform="translate(-6.843 -6.842)"
        fill={color}
      />
    </svg>
  );
};

export const Minus = ({
  width = "18",
  height = "4",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 4"
    >
      <g
        id="Group_164433"
        data-name="Group 164433"
        transform="translate(9.5 0.5)"
      >
        <g id="Group_164407" data-name="Group 164407">
          <rect
            id="Rectangle_164451"
            data-name="Rectangle 164451"
            width="17"
            height="3"
            rx="1.5"
            transform="translate(-9)"
            stroke={color}
            stroke-width="1"
          />
        </g>
      </g>
    </svg>
  );
};

export const ArrowLeft = ({
  width = "19.466",
  height = "12.514",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 19.466 12.514"
    >
      <path
        id="vector_Stroke_"
        data-name="vector (Stroke)"
        d="M12.64,12.145a1.39,1.39,0,0,0,1.965-.079L19.1,7.2a1.39,1.39,0,0,0,0-1.886L14.605.447a1.39,1.39,0,1,0-2.043,1.886L14.9,4.867H1.39a1.39,1.39,0,0,0,0,2.781H14.9L12.562,10.18A1.39,1.39,0,0,0,12.64,12.145Z"
        transform="translate(19.466 12.514) rotate(180)"
        fill={color}
      />
    </svg>
  );
};

export const FaceBook = ({
  width = "18",
  height = "18",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 17.989"
    >
      <path
        id="facebook_square"
        d="M21,5V18.99a2,2,0,0,1-2,2H15.25a.5.5,0,0,1-.5-.5v-6h2.34a.5.5,0,0,0,.49-.4l.36-1.8a.25.25,0,0,0-.24-.3H14.75V8.747A.25.25,0,0,1,15,8.5h2.5A.5.5,0,0,0,18,8V6.5a.5.5,0,0,0-.5-.5H15a3,3,0,0,0-3,3v3H10.77a.5.5,0,0,0-.5.5v1.5a.5.5,0,0,0,.5.5H12v6a.5.5,0,0,1-.5.5H5a2,2,0,0,1-2-2V5A2,2,0,0,1,5,3H19A2,2,0,0,1,21,5Z"
        transform="translate(-3 -3)"
        fill={color}
      />
    </svg>
  );
};

export const Google = ({
  width = "18",
  height = "18",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 18 17.989"
    >
      <path
        id="google"
        d="M21,11.785c0,4.148-2.21,9.2-8.87,9.2A9.067,9.067,0,0,1,3,11.995,9.067,9.067,0,0,1,12.13,3a9.223,9.223,0,0,1,5.7,2,.52.52,0,0,1,.19.37.549.549,0,0,1-.16.39A26.4,26.4,0,0,0,16,7.637a.49.49,0,0,1-.66.06,5.112,5.112,0,0,0-3.2-1,5.347,5.347,0,1,0,0,10.694c3,0,4.27-1.279,4.93-3.548H12.5a.5.5,0,0,1-.5-.5V10.7a.5.5,0,0,1,.5-.5h8a.45.45,0,0,1,.45.4A11.544,11.544,0,0,1,21,11.785Z"
        transform="translate(-3 -3)"
        fill={color}
      />
    </svg>
  );
};

export const Messenger = ({
  width = "20",
  height = "20",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
    >
      <path
        id="messenger"
        d="M2,11.495A9.758,9.758,0,0,1,12,2a9.758,9.758,0,0,1,10,9.495A9.758,9.758,0,0,1,12,20.99a10.184,10.184,0,0,1-2.29-.26,1,1,0,0,0-.61.05L6.39,21.919A1,1,0,0,1,5,20.99v-2.3a1,1,0,0,0-.29-.7A9.213,9.213,0,0,1,2,11.495ZM14.88,13.2l2.62-4a.459.459,0,0,0-.66-.62l-3.06,2.339-2.3-1.759a1.481,1.481,0,0,0-.91-.3h-.21a1.51,1.51,0,0,0-1.26.67L6.47,13.5a.5.5,0,0,0,.07.63.43.43,0,0,0,.56,0l3-2.249,2.19,1.689a1.49,1.49,0,0,0,.91.31h.43A1.49,1.49,0,0,0,14.88,13.2Z"
        transform="translate(-2 -1.997)"
        fill={color}
        fill-rule="evenodd"
      />
    </svg>
  );
};

export const Tiktok = ({
  width = "17",
  height = "20",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17 19.989"
    >
      <path
        id="tik_tok"
        d="M21,7.477v2a.52.52,0,0,1-.16.37.51.51,0,0,1-.37.13A7.913,7.913,0,0,1,16,8.237v7.756a6,6,0,1,1-6-6,5.079,5.079,0,0,1,.55,0,.49.49,0,0,1,.45.49v2a.48.48,0,0,1-.17.37.49.49,0,0,1-.4.12,3.106,3.106,0,0,0-.43.02,3,3,0,1,0,3,3V2.5a.5.5,0,0,1,.5-.5h2a.5.5,0,0,1,.5.45A5,5,0,0,0,20.55,7,.5.5,0,0,1,21,7.477Z"
        transform="translate(-4 -2)"
        fill={color}
      />
    </svg>
  );
};

export const Search = ({
  width = "28.784",
  height = "28.784",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 28.784 28.784"
    >
      <g id="Search" transform="translate(3.201 3.201)">
        <path
          id="Search-2"
          data-name="Search"
          d="M21.062,22.225l-.093-.078-3.5-3.414a10.856,10.856,0,0,1-6.713,2.3A10.651,10.651,0,0,1,0,10.519,10.652,10.652,0,0,1,10.756,0a10.652,10.652,0,0,1,10.757,10.52,10.348,10.348,0,0,1-2.832,7.106L22.139,21a.8.8,0,0,1,0,1.146.842.842,0,0,1-1.079.08ZM1.656,10.519a9.011,9.011,0,0,0,9.1,8.9,9.011,9.011,0,0,0,9.1-8.9,9.011,9.011,0,0,0-9.1-8.9A9.011,9.011,0,0,0,1.656,10.519Z"
          transform="translate(0 0)"
          stroke="rgba(0,0,0,0)"
          stroke-width="6.4"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const Close = ({
  width = "27.41",
  height = "27.41",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 27.41 27.41"
    >
      <g
        id="icons_Close_Circle_Line"
        data-name="icons/Close Circle/Line"
        transform="translate(0 0)"
      >
        <path
          id="Shape"
          d="M13.705,24.669A10.964,10.964,0,1,0,2.741,13.705,10.964,10.964,0,0,0,13.705,24.669Zm0,2.741A13.705,13.705,0,1,0,0,13.705,13.705,13.705,0,0,0,13.705,27.41Z"
          transform="translate(0 0)"
          fill={color}
          fill-rule="evenodd"
        />
        <path
          id="Shape-2"
          data-name="Shape"
          d="M.4.4A1.371,1.371,0,0,1,2.34.4L5.482,3.544,8.625.4A1.371,1.371,0,0,1,10.563,2.34L7.42,5.482l3.142,3.142a1.37,1.37,0,0,1-1.938,1.938L5.482,7.42,2.34,10.563A1.371,1.371,0,0,1,.4,8.625L3.544,5.482.4,2.34A1.371,1.371,0,0,1,.4.4Z"
          transform="translate(8.223 8.223)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const Website2 = ({
  width = "17.778",
  height = "17.778",
  color = "currentColor",
}) => {
  return (
    <svg
      t="1653444488874"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="3242"
      width="20"
      height="20"
    >
      <path
        d="M511.777943 68.191078c-245.204631 0-443.586864 198.60429-443.586864 443.808922s198.382233 443.808922 443.586864 443.808922 444.030979-198.60429 444.030979-443.808922S756.982574 68.191078 511.777943 68.191078zM819.11568 334.476841 688.191838 334.476841c-14.423501-55.476499-34.617425-108.733447-61.245899-157.995407C708.606797 204.440206 776.509303 261.025968 819.11568 334.476841zM512 158.506037c37.058011 53.256948 65.906036 112.505353 84.767616 175.96978L427.232384 334.475817C446.093964 271.01139 474.941989 211.762985 512 158.506037zM168.491459 600.76158c-7.322779-28.40391-11.538801-58.139142-11.538801-88.76158s4.216022-60.35767 11.538801-88.76158l149.785421 0c-3.550873 29.069059-5.991458 58.582233-5.991458 88.76158s2.440585 59.69252 6.213515 88.76158L168.491459 600.76158zM204.662263 689.523159l130.923842 0c14.423501 55.476499 34.617425 108.733447 61.245899 158.217465C315.171146 819.780829 247.267617 762.974032 204.662263 689.523159zM335.586105 334.476841 204.662263 334.476841c42.605354-73.449849 110.508883-130.257669 192.168718-158.217465C370.202507 225.743394 350.009605 279.000342 335.586105 334.476841zM512 865.493963c-36.835953-53.256948-65.683978-112.505353-84.767616-175.96978l169.535231 0C577.682955 752.987586 548.835953 812.235992 512 865.493963zM615.851253 600.76158 408.148747 600.76158c-4.216022-29.069059-7.100722-58.582233-7.100722-88.76158s2.8847-59.69252 7.100722-88.76158l207.702506 0c4.216022 29.069059 7.100722 58.582233 7.100722 88.76158S620.067274 571.69252 615.851253 600.76158zM627.167996 847.51959c26.628474-49.485041 46.821375-102.519931 61.245899-157.995407l130.923842 0C776.510326 762.974032 708.606797 819.558771 627.167996 847.51959zM705.500039 600.76158c3.550873-29.069059 6.213515-58.582233 6.213515-88.76158s-2.440585-59.69252-6.213515-88.76158l149.785421 0c7.322779 28.40391 11.760858 58.139142 11.760858 88.76158s-4.216022 60.35767-11.760858 88.76158L705.500039 600.76158z"
        p-id="3243"
        fill="#6f767e"
      ></path>
    </svg>
  );
};

export const Website = ({
  width = "13",
  height = "13",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17.778 17.778"
    >
      <g
        id="icons_Globe_Line"
        data-name="icons/Globe/Line"
        transform="translate(0)"
      >
        <path
          id="Shape"
          d="M8.889,16A7.111,7.111,0,1,0,1.778,8.889,7.111,7.111,0,0,0,8.889,16Zm0,1.778A8.889,8.889,0,1,0,0,8.889,8.889,8.889,0,0,0,8.889,17.778Z"
          transform="translate(0 0)"
          fill={color}
          fill-rule="evenodd"
        />
        <path
          id="Shape-2"
          data-name="Shape"
          d="M6,14.379a12.664,12.664,0,0,0,1.114-5.49A12.665,12.665,0,0,0,6,3.4c-.71-1.42-1.361-1.621-1.553-1.621S3.6,1.979,2.892,3.4a12.665,12.665,0,0,0-1.114,5.49,12.664,12.664,0,0,0,1.114,5.49C3.6,15.8,4.253,16,4.444,16S5.287,15.8,6,14.379Zm-1.553,3.4c2.455,0,4.444-3.98,4.444-8.889S6.9,0,4.444,0,0,3.98,0,8.889,1.99,17.778,4.444,17.778Z"
          transform="translate(4.444 0)"
          fill={color}
          fill-rule="evenodd"
        />
        <path
          id="Shape-3"
          data-name="Shape"
          d="M17.734,1.778q.044-.439.044-.889T17.734,0H.044Q0,.439,0,.889t.044.889Z"
          transform="translate(0 8)"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const SendIcon = ({
  width = "12.341",
  height = "12.341",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 12.341 12.341"
    >
      <g id="Frame_833" data-name="Frame 833" transform="translate(0)">
        <g
          id="icons_Location_Arrow_Line"
          data-name="icons/Location Arrow/Line"
          transform="translate(0 0)"
        >
          <path
            id="Shape"
            d="M10.149.126a1.58,1.58,0,0,1,2.066,2.066L8.472,11.174a1.9,1.9,0,0,1-3.619-.417l-.467-2.8-2.8-.467a1.9,1.9,0,0,1-.417-3.619Zm.9,1.58a.316.316,0,0,0-.413-.413L1.653,5.035a.632.632,0,0,0,.139,1.206l2.8.467A1.264,1.264,0,0,1,5.633,7.747l.467,2.8a.632.632,0,0,0,1.206.139Z"
            transform="translate(0 0)"
            fill={color}
            fill-rule="evenodd"
          />
        </g>
      </g>
    </svg>
  );
};

export const ArrowDown = ({
  width = "10.749",
  height = "6.569",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 10.749 6.569"
    >
      <path
        id="Shape"
        d="M6.219,10.4a1.194,1.194,0,0,0,0-1.689L2.883,5.375,6.219,2.039A1.194,1.194,0,0,0,4.53.35L.35,4.53a1.194,1.194,0,0,0,0,1.689L4.53,10.4A1.194,1.194,0,0,0,6.219,10.4Z"
        transform="translate(0 6.569) rotate(-90)"
        fill={color}
      />
    </svg>
  );
};

export const Setting = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.413"
      height="19.522"
      viewBox="0 0 18.413 19.522"
    >
      <g
        id="Iconly_Two-tone_Home"
        data-name="Iconly/Two-tone/Home"
        transform="translate(0.873 0.75)"
      >
        <g id="Setting">
          <path
            id="Path_33946"
            d="M16.434,5.012,15.85,4A1.794,1.794,0,0,0,13.4,3.338h0A1.785,1.785,0,0,1,10.959,2.7a1.716,1.716,0,0,1-.24-.858h0A1.794,1.794,0,0,0,8.925,0H7.749A1.785,1.785,0,0,0,5.964,1.794h0A1.794,1.794,0,0,1,4.17,3.562a1.716,1.716,0,0,1-.858-.24h0a1.794,1.794,0,0,0-2.446.661L.24,5.012A1.794,1.794,0,0,0,.892,7.458h0a1.794,1.794,0,0,1,.9,1.553,1.794,1.794,0,0,1-.9,1.553h0A1.785,1.785,0,0,0,.24,13h0l.592,1.021a1.794,1.794,0,0,0,2.446.7h0a1.776,1.776,0,0,1,2.437.652,1.716,1.716,0,0,1,.24.858h0a1.794,1.794,0,0,0,1.794,1.794H8.925a1.794,1.794,0,0,0,1.794-1.785h0a1.785,1.785,0,0,1,1.794-1.794,1.828,1.828,0,0,1,.858.24h0a1.794,1.794,0,0,0,2.446-.652h0L16.434,13a1.785,1.785,0,0,0-.652-2.446h0a1.785,1.785,0,0,1-.652-2.446,1.759,1.759,0,0,1,.652-.652h0a1.794,1.794,0,0,0,.652-2.437h0Z"
            transform="translate(0)"
            fill="none"
            stroke="#777e90"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.5"
            opacity="0.907"
          />
          <circle
            id="Ellipse_737"
            cx="2.472"
            cy="2.472"
            r="2.472"
            transform="translate(5.87 6.539)"
            fill="none"
            stroke="#777e90"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-miterlimit="10"
            stroke-width="1.5"
            opacity="0.4"
          />
        </g>
      </g>
    </svg>
  );
};

export const OrderHistory = () => {
  return (
    <svg
      id="Gift"
      xmlns="http://www.w3.org/2000/svg"
      width="16.677"
      height="16.677"
      viewBox="0 0 16.677 16.677"
    >
      <path
        id="Path_130"
        data-name="Path 130"
        d="M4,12H18.824v4.632a3.706,3.706,0,0,1-3.706,3.706H7.706A3.706,3.706,0,0,1,4,16.632Zm1.853,1.853v2.779a1.853,1.853,0,0,0,1.853,1.853h7.412a1.853,1.853,0,0,0,1.853-1.853V13.853Z"
        transform="translate(-3.074 -3.662)"
        fill="#12131a"
        fill-rule="evenodd"
      />
      <path
        id="Path_131"
        data-name="Path 131"
        d="M3,9.779A2.779,2.779,0,0,1,5.779,7H16.9a2.779,2.779,0,0,1,2.779,2.779v.926A2.779,2.779,0,0,1,16.9,13.485H5.779A2.779,2.779,0,0,1,3,10.706Zm2.779-.926a.926.926,0,0,0-.926.926v.926a.926.926,0,0,0,.926.926H16.9a.926.926,0,0,0,.926-.926V9.779a.926.926,0,0,0-.926-.926Z"
        transform="translate(-3 -3.294)"
        fill="#12131a"
        fill-rule="evenodd"
      />
      <path
        id="Path_132"
        data-name="Path 132"
        d="M7,5.779a2.78,2.78,0,0,1,4.632-2.072,2.779,2.779,0,1,1,1.853,4.851h-.926V19.677H10.706V8.559H9.779A2.779,2.779,0,0,1,7,5.779Zm3.706.926V5.779a.926.926,0,1,0-.926.926Zm1.853-.926v.926h.926a.926.926,0,1,0-.926-.926Z"
        transform="translate(-3.294 -3)"
        fill="#12131a"
        fill-rule="evenodd"
      />
    </svg>
  );
};

export const Logout = () => {
  return (
    <svg
      id="icons_Lock_Line"
      data-name="icons/Lock/Line"
      xmlns="http://www.w3.org/2000/svg"
      width="15.389"
      height="18.809"
      viewBox="0 0 15.389 18.809"
    >
      <path
        id="Shape"
        d="M7.695,1.71c-1.515,0-2.865.055-3.968.125A2.036,2.036,0,0,0,1.8,3.739c-.053.739-.091,1.518-.091,2.246s.037,1.507.091,2.246a2.036,2.036,0,0,0,1.926,1.9c1.1.07,2.453.125,3.968.125s2.865-.055,3.968-.125a2.036,2.036,0,0,0,1.926-1.9c.053-.739.091-1.518.091-2.246s-.037-1.507-.091-2.246a2.036,2.036,0,0,0-1.926-1.9C10.56,1.765,9.21,1.71,7.695,1.71ZM3.618.129A3.746,3.746,0,0,0,.1,3.616C.04,4.38,0,5.2,0,5.985s.04,1.6.1,2.369a3.746,3.746,0,0,0,3.523,3.487c1.134.072,2.52.129,4.077.129s2.943-.057,4.077-.129a3.746,3.746,0,0,0,3.523-3.487c.055-.765.1-1.587.1-2.369s-.04-1.6-.1-2.369A3.746,3.746,0,0,0,11.772.129C10.638.057,9.251,0,7.695,0S4.752.057,3.618.129Z"
        transform="translate(0 6.84)"
        fill="#777e90"
        fill-rule="evenodd"
      />
      <path
        id="Shape-2"
        data-name="Shape"
        d="M2.565,3.191a1.71,1.71,0,1,0-1.71,0V4.275a.855.855,0,1,0,1.71,0Z"
        transform="translate(5.985 10.26)"
        fill="#777e90"
      />
      <path
        id="Shape-3"
        data-name="Shape"
        d="M0,4.275a4.275,4.275,0,0,1,8.55,0v3.42a.855.855,0,1,1-1.71,0V4.275a2.565,2.565,0,1,0-5.13,0v3.42a.855.855,0,1,1-1.71,0Z"
        transform="translate(3.42 0)"
        fill="#777e90"
      />
    </svg>
  );
};

export const SettingIcon = () => {
  return (
    <svg
      id="Group_164182"
      data-name="Group 164182"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="18.013"
      height="18.003"
      viewBox="0 0 18.013 18.003"
    >
      <defs>
        <clipPath id="clip-path">
          <rect
            id="Rectangle_164357"
            data-name="Rectangle 164357"
            width="18"
            height="17.996"
            fill="none"
          />
        </clipPath>
        <clipPath id="clip-path-2">
          <rect
            id="Rectangle_164358"
            data-name="Rectangle 164358"
            width="18"
            height="17.996"
            transform="translate(0.013 0.007)"
            fill="none"
          />
        </clipPath>
      </defs>
      <g id="Group_164179" data-name="Group 164179" transform="translate(0 0)">
        <g
          id="Group_164178"
          data-name="Group 164178"
          clip-path="url(#clip-path)"
        >
          <path
            id="Path_45267"
            data-name="Path 45267"
            d="M12.821,13.508,15.969,14.7a9,9,0,0,0,.8-1.144L14.582,10.94l3.314-.576c.027-.175.05-.35.066-.528.024-.26.034-.517.037-.773L14.806,7.891l2.583-2.156a8.99,8.99,0,0,0-.519-1.106l-3.36.551L14.7,2.03a9.021,9.021,0,0,0-1.064-.75L11,3.436,10.457.118c-.2-.033-.41-.062-.619-.082C9.6.013,9.358,0,9.12,0L7.928,3.187,5.788.59a9,9,0,0,0-1.179.553L5.168,4.5,2.017,3.319a8.992,8.992,0,0,0-.828,1.208L3.4,7.116.09,7.727q-.031.215-.052.434C.011,8.452,0,8.74,0,9.026l3.207,1.14L.647,12.348a8.987,8.987,0,0,0,.489,1.026l3.357-.552L3.306,15.97a9,9,0,0,0,1.065.75l2.635-2.158L7.55,17.88c.2.033.406.062.613.081.233.022.463.031.693.035l1.2-3.181,2.133,2.6a9.009,9.009,0,0,0,1.182-.55Z"
            transform="translate(0 0)"
            fill="#58606b"
          />
        </g>
      </g>
      <g id="Group_164181" data-name="Group 164181" transform="translate(0 0)">
        <g
          id="Group_164180"
          data-name="Group 164180"
          clip-path="url(#clip-path-2)"
        >
          <path
            id="Path_45268"
            data-name="Path 45268"
            d="M25.385,20.692A5.187,5.187,0,1,1,20.7,15.045a5.187,5.187,0,0,1,4.682,5.647"
            transform="translate(-11.034 -11.023)"
            fill="#58606b"
          />
          <path
            id="Path_45269"
            data-name="Path 45269"
            d="M25.462,20.729a5.187,5.187,0,1,1-4.682-5.647A5.187,5.187,0,0,1,25.462,20.729Z"
            transform="translate(-11.634 -11.572)"
            fill="none"
            stroke="#fff"
            stroke-miterlimit="10"
            stroke-width="1"
          />
          <path
            id="Path_45270"
            data-name="Path 45270"
            d="M27.083,24.753a2.57,2.57,0,1,1-2.32-2.8,2.57,2.57,0,0,1,2.32,2.8"
            transform="translate(-15.755 -15.944)"
            fill="#fff"
          />
        </g>
      </g>
    </svg>
  );
};

export const CaretRight = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="11.834"
      height="19.425"
      viewBox="0 0 11.834 19.425"
    >
      <path
        id="Path_45254"
        data-name="Path 45254"
        d="M0,0,4.745,4.744,7.591,7.591,0,15.183"
        transform="translate(2.121 2.121)"
        fill="none"
        stroke="#23262f"
        stroke-linecap="round"
        stroke-width="3"
      />
    </svg>
  );
};

export const CaretBottom = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19.425"
      height="11.834"
      viewBox="0 0 19.425 11.834"
    >
      <path
        id="Path_45254"
        data-name="Path 45254"
        d="M0,0,4.745,4.744,7.591,7.591,0,15.183"
        transform="translate(16.155 5) rotate(90)"
        fill="none"
        stroke="#23262f"
        stroke-linecap="round"
        stroke-width="3"
      />
    </svg>
  );
};

export const CaretLeft = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14.63"
      height="24.311"
      viewBox="0 0 14.63 24.311"
    >
      <path
        id="Path_45205"
        data-name="Path 45205"
        d="M0,0,6.051,6.05l3.63,3.63L0,19.361"
        transform="translate(12.155 21.836) rotate(180)"
        fill="none"
        stroke="#23262f"
        stroke-linecap="round"
        stroke-width="3.5"
      />
    </svg>
  );
};

export const EditPencil = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="29.93"
      height="20.485"
      viewBox="0 0 29.93 20.485"
    >
      <g
        id="Edit_vector_"
        data-name="Edit (vector)"
        transform="translate(0 1.029)"
      >
        <rect
          id="Rectangle_164298"
          data-name="Rectangle 164298"
          width="25"
          height="12"
          rx="3"
          transform="translate(0 7.456)"
          fill="#23262f"
        />
        <line
          id="Line_237"
          data-name="Line 237"
          x2="9.479"
          transform="translate(4.203 11.519)"
          fill="none"
          stroke="#fff"
          stroke-linecap="round"
          stroke-width="2"
        />
        <line
          id="Line_238"
          data-name="Line 238"
          x2="9.479"
          transform="translate(4.203 15.253)"
          fill="none"
          stroke="#fff"
          stroke-linecap="round"
          stroke-width="2"
        />
        <rect
          id="Rectangle_164299"
          data-name="Rectangle 164299"
          width="5.603"
          height="10.272"
          transform="translate(23.609 11.691) rotate(-149)"
          fill="#23262f"
          stroke="#fff"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <path
          id="Path_45233"
          data-name="Path 45233"
          d="M2.8,0,5.6,3.335V5.6H0V3.268Z"
          transform="translate(20.725 16.493) rotate(-149)"
          fill="#23262f"
          stroke="#fff"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
      </g>
    </svg>
  );
};

export const Message = ({
  width = "17.5",
  height = "17.5",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17.5 17.5"
    >
      <g id="Chat" transform="translate(-1.25 -1.25)">
        <path
          id="Path_17583"
          data-name="Path 17583"
          d="M7.461,12.924a.934.934,0,1,1,.935-.935A.935.935,0,0,1,7.461,12.924Zm3.634,0a.934.934,0,1,1,.935-.935A.935.935,0,0,1,11.1,12.924Zm2.7-.935a.935.935,0,1,0,.935-.933A.935.935,0,0,0,13.8,11.989Z"
          transform="translate(-0.905 -1.811)"
          fill={color}
          fill-rule="evenodd"
        />
        <path
          id="Path_17584"
          data-name="Path 17584"
          d="M10.016,2A8,8,0,0,0,2,10.012a8.467,8.467,0,0,0,1.08,4,.841.841,0,0,1,.056.722L2.6,16.526a.5.5,0,0,0,.656.624l1.616-.48a1.357,1.357,0,0,1,1.192.288A8,8,0,1,0,10.016,2Z"
          fill="none"
          stroke="#200e32"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  );
};

export const Email = ({
  width = "17.501",
  height = "15.741",
  color = "currentColor",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 17.501 15.741"
    >
      <g id="Message" transform="translate(-1.25 0.75)">
        <path
          id="Path_17585"
          data-name="Path 17585"
          d="M15.367,9.061l-3.549,2.857a1.85,1.85,0,0,1-2.285,0L5.954,9.061"
          transform="translate(-0.664 -4.434)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
        />
        <path
          id="Path_17586"
          data-name="Path 17586"
          d="M6.067,3.5h7.844A4.124,4.124,0,0,1,16.89,4.823a4.174,4.174,0,0,1,1.1,3.082v5.431a4.174,4.174,0,0,1-1.1,3.082,4.124,4.124,0,0,1-2.979,1.323H6.067A4.133,4.133,0,0,1,2,13.336V7.9A4.133,4.133,0,0,1,6.067,3.5Z"
          transform="translate(0 -3.5)"
          fill="none"
          stroke={color}
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="1.5"
          fill-rule="evenodd"
        />
      </g>
    </svg>
  );
};

export const PlusIcon = ({
  color = "#696969",
  width = "61.063",
  height = "60.629",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 61.063 60.629"
    >
      <path
        id="plus"
        d="M24.984,5.545,25,24.9H5.619a5.516,5.516,0,0,0-5.09,3.369A5.511,5.511,0,0,0,.543,32.56a5.549,5.549,0,0,0,5.106,3.364H25l.012,19.227a5.433,5.433,0,0,0,.435,2.133,5.531,5.531,0,0,0,10.166,0,5.434,5.434,0,0,0,.435-2.133l.012-19.227H55.414A5.556,5.556,0,0,0,60.52,32.56a5.5,5.5,0,0,0-5.076-7.66H36.068l.012-19.355a5.548,5.548,0,1,0-11.1,0Z"
        fill={color}
      />
    </svg>
  );
};

export const Trash = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="trash" transform="translate(-108)">
        <path
          id="Vector"
          d="M18,.5C14.67.17,11.32,0,7.98,0A59.068,59.068,0,0,0,2.04.3L0,.5"
          transform="translate(111 5.48)"
          fill="none"
          stroke="#ee4141"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
        <path
          id="Vector-2"
          data-name="Vector"
          d="M0,2.97.22,1.66C.38.71.5,0,2.19,0H4.81C6.5,0,6.63.75,6.78,1.67L7,2.97"
          transform="translate(116.5 2)"
          fill="none"
          stroke="#ee4141"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
        <path
          id="Vector-3"
          data-name="Vector"
          d="M13.7,0l-.65,10.07c-.11,1.57-.2,2.79-2.99,2.79H3.64C.85,12.86.76,11.64.65,10.07L0,0"
          transform="translate(113.15 9.14)"
          fill="none"
          stroke="#ee4141"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
        <path
          id="Vector-4"
          data-name="Vector"
          d="M0,0H24V24H0Z"
          transform="translate(108)"
          fill="none"
          opacity="0"
        />
      </g>
    </svg>
  );
};

export const Check = ({
  color = "currentColor",
  width = "7.009",
  height = "5.071",
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 7.009 5.071"
    >
      <path
        id="Path_45246"
        data-name="Path 45246"
        d="M148.163,166.347l-3.877,3.877a.6.6,0,0,1-.843,0l-1.939-1.939a.6.6,0,0,1,.843-.843l1.517,1.517,3.456-3.456a.6.6,0,1,1,.843.843Zm0,0"
        transform="translate(-141.328 -165.328)"
        fill={color}
      />
    </svg>
  );
};

export const Info = ({
  width = "16",
  height = "16",
  color = "currentColor",
}) => {
  return (
    <svg
      id="info"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 16 16"
    >
      <g id="Group_164105" data-name="Group 164105">
        <path
          id="Path_45262"
          data-name="Path 45262"
          d="M8,0a8,8,0,1,0,8,8A8,8,0,0,0,8,0Zm.822,11.176c0,.253-.369.505-.821.505-.474,0-.811-.253-.811-.505V7.164c0-.295.337-.495.811-.495.453,0,.821.2.821.495ZM8,5.7a.824.824,0,0,1-.863-.758A.816.816,0,0,1,8,4.194a.812.812,0,0,1,.853.748A.821.821,0,0,1,8,5.7Z"
          fill={color}
        />
      </g>
    </svg>
  );
};

export const EyeSlash = ({ width = "22.828", height = "22.828" }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 22.828 22.828"
    >
      <g
        id="Group_89113"
        data-name="Group 89113"
        transform="translate(-1063.586 -182.664)"
      >
        <path
          id="Path_6002"
          data-name="Path 6002"
          d="M16.141,16.46A9,9,0,0,1,10.832,18.3C4.575,18.3,1,11.15,1,11.15A16.491,16.491,0,0,1,5.523,5.841M8.955,4.215A8.152,8.152,0,0,1,10.832,4c6.257,0,9.832,7.15,9.832,7.15A16.535,16.535,0,0,1,18.733,14m-6.006-.956a2.681,2.681,0,1,1-3.79-3.79"
          transform="translate(1064.168 182.928)"
          fill="none"
          stroke="#6f767e"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
        <line
          id="Line_21"
          data-name="Line 21"
          x2="20"
          y2="20"
          transform="translate(1065 184.078)"
          fill="none"
          stroke="#6f767e"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-width="2"
        />
      </g>
    </svg>
  );
};

export const Eye = ({ width = "22.828", height = "22.828" }) => {
  return (
    <svg
      class="svg-icon"
      width={width}
      height={height}
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M512 384a128.853333 128.853333 0 0 0-128 128c0 70.058667 57.941333 128 128 128 70.016 0 128-57.941333 128-128 0-70.016-57.984-128-128-128z"
        fill=""
        stroke="#6f767e"
      />
      <path
        d="M512 213.333333c-325.674667 0-423.552 282.325333-424.448 285.184a42.410667 42.410667 0 0 0 0 27.008C88.448 528.341333 186.325333 810.666667 512 810.666667s423.552-282.325333 424.448-285.184a42.410667 42.410667 0 0 0 0-27.008C935.552 495.658667 837.674667 213.333333 512 213.333333z m0 512c-228.309333 0-316.757333-164.096-338.176-213.333333C195.328 462.592 283.818667 298.666667 512 298.666667c228.309333 0 316.757333 164.096 338.176 213.333333-21.504 49.408-109.994667 213.333333-338.176 213.333333z"
        fill=""
        stroke="#6f767e"
      />
    </svg>
  );
};
export const Lock = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="20"
      viewBox="0 0 16 20"
    >
      <g
        id="Search_input"
        data-name="Search input"
        transform="translate(-4 -2)"
      >
        <g id="Left">
          <g id="UI_icon_lock_light" data-name="UI icon/lock/light">
            <path
              id="Union"
              d="M3,3.732a2,2,0,1,0-2,0V5A1,1,0,0,0,3,5Z"
              transform="translate(10 12)"
              fill="#6f767e"
            />
            <path
              id="Union-2"
              data-name="Union"
              d="M13,20H3a3,3,0,0,1-3-3V9A3,3,0,0,1,3,6V5A5,5,0,1,1,13,5V6a3,3,0,0,1,3,3v8A3,3,0,0,1,13,20ZM3,8A1,1,0,0,0,2,9v8a1,1,0,0,0,1,1H13a1,1,0,0,0,1-1V9a1,1,0,0,0-1-1ZM8,2A3,3,0,0,0,5,5V6h6V5A3,3,0,0,0,8,2Z"
              transform="translate(4 2)"
              fill="#6f767e"
            />
          </g>
        </g>
      </g>
    </svg>
  );
};

export const Emoji = () => {
  return (
    <svg
      id="icons_Smile_Line"
      data-name="icons/Smile/Line"
      xmlns="http://www.w3.org/2000/svg"
      width="26.672"
      height="26.672"
      viewBox="0 0 26.672 26.672"
    >
      <path
        id="Union"
        d="M2.667,13.336A10.669,10.669,0,1,1,13.336,24,10.669,10.669,0,0,1,2.667,13.336ZM13.336,0A13.336,13.336,0,1,0,26.672,13.336,13.336,13.336,0,0,0,13.336,0ZM9.3,15.689a1.334,1.334,0,1,0-2.592.627,6.444,6.444,0,0,0,2.418,3.631,7.08,7.08,0,0,0,8.425,0,6.445,6.445,0,0,0,2.418-3.631,1.334,1.334,0,0,0-2.592-.627,3.777,3.777,0,0,1-1.426,2.125,4.414,4.414,0,0,1-5.225,0A3.778,3.778,0,0,1,9.3,15.689Zm1.609-3.709a1.334,1.334,0,0,1-1.55-1.074.712.712,0,0,0-.021-.087.712.712,0,0,0-.021.087,1.334,1.334,0,0,1-2.624-.476,3.144,3.144,0,0,1,.85-1.664,2.491,2.491,0,0,1,3.592,0,3.144,3.144,0,0,1,.85,1.664A1.334,1.334,0,0,1,10.907,11.981Zm6.451-1.074a1.334,1.334,0,1,0,2.624-.476,3.143,3.143,0,0,0-.85-1.664,2.491,2.491,0,0,0-3.592,0,3.143,3.143,0,0,0-.85,1.664,1.334,1.334,0,1,0,2.624.476.707.707,0,0,1,.021-.087A.707.707,0,0,1,17.358,10.907Z"
        fill="#777e90"
        fill-rule="evenodd"
      />
    </svg>
  );
};

export const Star = ({ width = "14", height = "14" }) => {
  return (
    <svg
      id="icons_16_general_star"
      data-name="icons/16/general/star"
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 14 14"
    >
      <path
        id="Vector_Stroke_"
        data-name="Vector (Stroke)"
        d="M8.479.96,9.741,3.61l2.834.427a1.766,1.766,0,0,1,.911,2.98L11.45,9.069l.479,2.892A1.674,1.674,0,0,1,9.54,13.807L7,12.424,4.46,13.806a1.674,1.674,0,0,1-2.39-1.845l.479-2.892L.514,7.017a1.766,1.766,0,0,1,.91-2.981L4.259,3.61,5.522.96A1.619,1.619,0,0,1,8.479.96Z"
        transform="translate(0 0)"
      />
    </svg>
  );
};
export const Profile = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g id="Group_3" data-name="Group 3" transform="translate(8690.5 2086)">
        <g
          id="Nav_item"
          data-name="Nav item"
          transform="translate(-8704.5 -2100)"
        >
          <g id="Left" transform="translate(12 12)">
            <g
              id="UI_icon_profile_circled_light"
              data-name="UI icon/profile_circled/light"
            >
              <g id="Vector" transform="translate(2 2)">
                <path
                  id="B6568794-B5CC-4FDD-B344-1DE4E5EF7C5A"
                  d="M4,8A4,4,0,1,1,8,4,4,4,0,0,1,4,8ZM4,2A2,2,0,1,0,6,4,2,2,0,0,0,4,2Z"
                  transform="translate(6 4)"
                  fill="#6f767e"
                />
                <path
                  id="_09760FF9-3E89-4DBD-A280-38BEDE6D663F"
                  data-name="09760FF9-3E89-4DBD-A280-38BEDE6D663F"
                  d="M10,20a10,10,0,1,1,6.559-2.451c-.066.057-.131.113-.2.167A10.017,10.017,0,0,1,10,20Zm0-5a4.971,4.971,0,0,0-3.964,1.95A8.009,8.009,0,0,0,9.733,18c.09,0,.168,0,.24,0H10c.078,0,.162,0,.258,0a8,8,0,0,0,3.705-1.045A4.971,4.971,0,0,0,10,15Zm0-2a6.955,6.955,0,0,1,5.563,2.75A8,8,0,1,0,2,10a7.937,7.937,0,0,0,2.438,5.75A6.952,6.952,0,0,1,10,13Z"
                  fill="#6f767e"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};
export const UserName = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18.317"
      height="20.916"
      viewBox="0 0 18.317 20.916"
    >
      <g
        id="UI_icon_zap_light"
        data-name="UI icon/zap/light"
        transform="translate(-2.841 -1.542)"
      >
        <path
          id="Union_Stroke_"
          data-name="Union (Stroke)"
          d="M8.365,20.916a3.146,3.146,0,0,1-2.529-1.321,2.889,2.889,0,0,1-.336-2.7L6.67,13.6H3.006A3,3,0,0,1,.8,8.568L7.784.986A2.9,2.9,0,0,1,9.952,0,3.146,3.146,0,0,1,12.48,1.321a2.89,2.89,0,0,1,.337,2.7l-1.17,3.29h3.664a3,3,0,0,1,2.207,5.033L10.533,19.93A2.9,2.9,0,0,1,8.365,20.916Zm1.613-18.9a.965.965,0,0,0-.723.329L2.271,9.923A1,1,0,0,0,3.006,11.6h5.08a1,1,0,0,1,.942,1.335L7.384,17.562a.964.964,0,0,0,.112.9,1.049,1.049,0,0,0,.843.44.965.965,0,0,0,.723-.329l6.985-7.582a1,1,0,0,0-.735-1.678H10.229A1,1,0,0,1,9.288,7.98l1.645-4.626a.963.963,0,0,0-.112-.9A1.049,1.049,0,0,0,9.978,2.013Z"
          transform="translate(2.842 1.542)"
          fill="#6f767e"
        />
      </g>
    </svg>
  );
};
export const ValidCheck = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="17"
      height="11.172"
      viewBox="0 0 17 11.172"
    >
      <g
        id="UI_icon_check_filled"
        data-name="UI icon/check/filled"
        transform="translate(-79 -6)"
      >
        <path
          id="Vector_408_Stroke_"
          data-name="Vector 408 (Stroke)"
          d="M16.707.293a1,1,0,0,1,0,1.414L8.121,10.293a3,3,0,0,1-4.243,0L.293,6.707A1,1,0,0,1,1.707,5.293L5.293,8.879a1,1,0,0,0,1.414,0L15.293.293A1,1,0,0,1,16.707.293Z"
          transform="translate(79 6)"
          fill="#1ebc17"
        />
      </g>
    </svg>
  );
};
export const Share = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="18"
      height="18"
      viewBox="0 0 18 18"
    >
      <image
        id="share"
        width="18"
        height="18"
        xlinkHref="data:image/png;base64,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"
      />
    </svg>
  );
};

export const Schedule = () => {
  return (
    <svg
      id="UI_icon_schedule_light"
      data-name="UI icon/schedule/light"
      xmlns="http://www.w3.org/2000/svg"
      width="21"
      height="21"
      viewBox="0 0 21 21"
    >
      <path
        id="Subtract"
        d="M6,1A1,1,0,0,0,4,1V2H3A3,3,0,0,0,0,5V17a3,3,0,0,0,3,3h8.682A6.03,6.03,0,0,1,9.8,18H3a1,1,0,0,1-1-1V5A1,1,0,0,1,3,4H4V5A1,1,0,0,0,6,5V4h8V5a1,1,0,0,0,2,0V4h1a1,1,0,0,1,1,1V9.8a6.03,6.03,0,0,1,2,1.88V5a3,3,0,0,0-3-3H16V1a1,1,0,0,0-2,0V2H6Z"
        fill="#272b30"
      />
      <path
        id="Ellipse_134_Stroke_"
        data-name="Ellipse 134 (Stroke)"
        d="M6,12a6,6,0,1,1,6-6A6.007,6.007,0,0,1,6,12ZM6,2a4,4,0,1,0,4,4A4.005,4.005,0,0,0,6,2Z"
        transform="translate(9 9)"
        fill="#272b30"
      />
      <path
        id="Vector_479_Stroke_"
        data-name="Vector 479 (Stroke)"
        d="M1,0A1,1,0,0,1,2,1V2.586l.707.707A1,1,0,0,1,1.293,4.707l-1-1A1,1,0,0,1,0,3V1A1,1,0,0,1,1,0Z"
        transform="translate(14 12)"
        fill="#272b30"
      />
    </svg>
  );
};

export const Pencil = () => {
  return (
    <svg
      id="UI_icon_design_light"
      data-name="UI icon/design/light"
      xmlns="http://www.w3.org/2000/svg"
      width="20.139"
      height="20.142"
      viewBox="0 0 20.139 20.142"
    >
      <path
        id="Union"
        d="M14.312,20.142a2.98,2.98,0,0,1-2.121-.879L9.383,16.455l-2.2,2.2a1,1,0,0,1-.511.274l-5.3,1.06a1.022,1.022,0,0,1-.2.02,1,1,0,0,1-.977-1.2l1.061-5.3A1,1,0,0,1,1.526,13l2.2-2.2L2.3,9.371l-.006-.007-.007-.006L.877,7.949a3.005,3.005,0,0,1,0-4.243L3.705.878a3,3,0,0,1,4.243,0L10.8,3.728l2.535-2.535a3,3,0,0,1,4.243,0L18.99,2.606a3,3,0,0,1,0,4.243L16.454,9.385l2.808,2.807a3,3,0,0,1,0,4.243l-2.829,2.829A2.98,2.98,0,0,1,14.312,20.142ZM12.9,14.728a1,1,0,0,1,.707,1.707l-.707.707.707.707a1,1,0,0,0,1.415,0l2.828-2.828a1,1,0,0,0,0-1.415L15.04,10.8,10.8,15.041l.686.686.707-.707A.994.994,0,0,1,12.9,14.728Zm-.979-9.293h0L3.154,14.2l-.707,3.535,3.535-.707,8.764-8.764L11.919,5.435Zm-6.8.1a1,1,0,0,1,.707,1.707L4.413,8.657l.727.728L9.383,5.141,6.534,2.293a1,1,0,0,0-1.415,0L2.291,5.121a1,1,0,0,0,0,1.415L3,7.242,4.413,5.828A.993.993,0,0,1,5.12,5.535ZM15.454,2.313a.994.994,0,0,0-.707.293L13.333,4.021l2.829,2.828,1.414-1.414a1,1,0,0,0,0-1.414L16.161,2.606A.994.994,0,0,0,15.454,2.313Z"
        transform="translate(0 0)"
        fill="#1a1d1f"
      />
    </svg>
  );
};

export const Camera = () => {
  return (
    <svg
      id="UI_icon_video_recorder_light"
      data-name="UI icon/video_recorder/light"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="14"
      viewBox="0 0 20 14"
    >
      <path
        id="Union"
        d="M12,14H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0h9a3,3,0,0,1,3,3v.571l1.837-1.312a1.98,1.98,0,0,1,1.155-.376,2.01,2.01,0,0,1,2.007,2v6.227a2.01,2.01,0,0,1-2.007,2,1.98,1.98,0,0,1-1.155-.376L15,10.428V11A3,3,0,0,1,12,14ZM3,2A1,1,0,0,0,2,3v8a1,1,0,0,0,1,1h9a1,1,0,0,0,1-1V3a1,1,0,0,0-1-1ZM18,3.886,15,6.029V7.97l3,2.143Z"
        fill="#1a1d1f"
      />
    </svg>
  );
};

export const People = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      viewBox="0 0 20 20"
    >
      <g
        id="UI_icon_profile_circled_light"
        data-name="UI icon/profile_circled/light"
        transform="translate(-2 -2)"
      >
        <g id="Vector" transform="translate(2 2)">
          <path
            id="B7941E78-50AC-4D8A-B07C-4A8058701420"
            d="M4,8A4,4,0,1,1,8,4,4,4,0,0,1,4,8ZM4,2A2,2,0,1,0,6,4,2,2,0,0,0,4,2Z"
            transform="translate(6 4)"
            fill="#1a1d1f"
          />
          <path
            id="A5CEA213-B7B0-4CC6-B140-7DD9BE7F6FBE"
            d="M10,20a10,10,0,1,1,6.559-2.451c-.066.057-.131.113-.2.167A10.017,10.017,0,0,1,10,20Zm0-5a4.971,4.971,0,0,0-3.964,1.95A8.009,8.009,0,0,0,9.733,18c.09,0,.168,0,.24,0H10c.078,0,.162,0,.258,0a8,8,0,0,0,3.705-1.045A4.971,4.971,0,0,0,10,15Zm0-2a6.955,6.955,0,0,1,5.563,2.75A8,8,0,1,0,2,10a7.937,7.937,0,0,0,2.438,5.75A6.952,6.952,0,0,1,10,13Z"
            fill="#1a1d1f"
          />
        </g>
      </g>
    </svg>
  );
};

export const UpArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16.172"
      viewBox="0 0 20 16.172"
    >
      <g
        id="UI_icon_arrow_up_down_filled"
        data-name="UI icon/arrow_up_down/filled"
        transform="translate(-2 -3.914)"
      >
        <path
          id="Union"
          d="M1.707,5.293A1,1,0,0,1,.293,3.879L3.586.586a2,2,0,0,1,2.828,0L9.707,3.879A1,1,0,1,1,8.293,5.293L6,3V15.086a1,1,0,0,1-2,0V3Z"
          transform="translate(2 3.914)"
          fill="#1a1d1f"
        />
        <path
          id="Union-2"
          data-name="Union"
          d="M6,1A1,1,0,1,0,4,1V13.086L1.707,10.793A1,1,0,1,0,.293,12.207L3.586,15.5a2,2,0,0,0,2.828,0l3.293-3.293a1,1,0,1,0-1.414-1.414L6,13.086Z"
          transform="translate(12 4)"
          fill="#1a1d1f"
        />
      </g>
    </svg>
  );
};

export const LinkClicks = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="20"
      viewBox="0 0 14 20"
    >
      <g
        id="UI_icon_mouse_light"
        data-name="UI icon/mouse/light"
        transform="translate(-5 -2)"
      >
        <path
          id="Rectangle_259_Stroke_"
          data-name="Rectangle 259 (Stroke)"
          d="M7,20a7.008,7.008,0,0,1-7-7V7A7,7,0,0,1,14,7v6A7.008,7.008,0,0,1,7,20ZM7,2A5.006,5.006,0,0,0,2,7v6a5,5,0,1,0,10,0V7A5.006,5.006,0,0,0,7,2Z"
          transform="translate(5 2)"
          fill="#1a1d1f"
        />
        <path
          id="Vector_479_Stroke_"
          data-name="Vector 479 (Stroke)"
          d="M0,1A1,1,0,0,1,1,0H4A1,1,0,0,1,4,2H1A1,1,0,0,1,0,1Z"
          transform="translate(13 6) rotate(90)"
          fill="#1a1d1f"
        />
      </g>
    </svg>
  );
};

export const ArrowUp = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="14"
      viewBox="0 0 12 14"
    >
      <g id="Frame_87" data-name="Frame 87" transform="translate(1 1)">
        <path
          id="Vector_618"
          data-name="Vector 618"
          d="M10.293,6.707,6,2.414,1.707,6.707A1,1,0,1,1,.293,5.293l5-5L6,1H6L5.293.293a1,1,0,0,1,1.414,0l5,5a1,1,0,1,1-1.414,1.414Z"
          transform="translate(-1 -1)"
          fill="currentColor"
        />
        <path
          id="Vector_619"
          data-name="Vector 619"
          d="M0,13V1H2V13a1,1,0,1,1-2,0ZM0,1A1,1,0,0,1,2,1Z"
          transform="translate(4 -1)"
          fill="currentColor"
        />
      </g>
    </svg>
  );
};

export const InfoIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="15.214"
      height="15.214"
      viewBox="0 0 15.214 15.214"
    >
      <g
        id="UI_icon_info_filled"
        data-name="UI icon/info/filled"
        transform="translate(0 0)"
      >
        <path
          id="Subtract"
          d="M7.607,15.214A7.607,7.607,0,0,1,7.607,0a14.954,14.954,0,0,1,3.809,1.021c.038.037,3.8,3.706,3.8,6.586A7.615,7.615,0,0,1,7.607,15.214Zm0-8.367a.761.761,0,0,0-.76.76v3.8a.76.76,0,1,0,1.521,0v-3.8A.761.761,0,0,0,7.607,6.846Zm0-3.043a.76.76,0,1,0,.76.76A.761.761,0,0,0,7.607,3.8Z"
          transform="translate(0 0)"
          fill="#9a9fa5"
        />
      </g>
    </svg>
  );
};

export const OpenUrl = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.395"
      height="23.395"
      viewBox="0 0 23.395 23.395"
    >
      <g
        id="UI_icon_arrow_forward_light"
        data-name="UI icon/arrow_forward/light"
        transform="translate(0 12.789) rotate(-45)"
      >
        <path
          id="Union"
          d="M10.293,13.293a1,1,0,0,0,1.414,1.414L17.5,8.914a2,2,0,0,0,0-2.828L11.707.293a1,1,0,0,0-1.414,1.414L15.086,6.5H1a1,1,0,1,0,0,2H15.086Z"
          fill="#1a1d1f"
        />
      </g>
    </svg>
  );
};
export const Policy = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="16"
      height="16"
      viewBox="0 0 16 16"
    >
      <image
        id="Image_161"
        data-name="Image 161"
        width="16"
        height="16"
        xlinkHref="data:image/png;base64,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"
      />
    </svg>
  );
};

export const More = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23"
      height="5"
      viewBox="0 0 23 5"
    >
      <g
        id="Group_164863"
        data-name="Group 164863"
        transform="translate(-469 -314)"
      >
        <circle
          id="Ellipse_650"
          data-name="Ellipse 650"
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(469 314)"
          fill="#0f0f0f"
        />
        <circle
          id="Ellipse_651"
          data-name="Ellipse 651"
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(478 314)"
          fill="#0f0f0f"
        />
        <circle
          id="Ellipse_652"
          data-name="Ellipse 652"
          cx="2.5"
          cy="2.5"
          r="2.5"
          transform="translate(487 314)"
          fill="#0f0f0f"
        />
      </g>
    </svg>
  );
};

export const ContactBrand = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Group_164198" data-name="Group 164198" transform="translate(-226)">
        <rect
          id="Rectangle_164361"
          data-name="Rectangle 164361"
          width="24"
          height="24"
          transform="translate(226)"
          fill="#fff"
          opacity="0"
        />
        <g id="layer1" transform="translate(229 5)">
          <path
            id="path1983"
            d="M3.077-760.01a2.552,2.552,0,0,0-2.547,2.542v3.82A2.557,2.557,0,0,0,3.077-751.1v1.912a.637.637,0,0,0,.394.583.639.639,0,0,0,.691-.136L6.52-751.1h4.2a2.553,2.553,0,0,0,2.542-2.548v-3.82a2.548,2.548,0,0,0-2.542-2.542Zm0,1.274h7.64a1.254,1.254,0,0,1,1.274,1.268v3.82a1.257,1.257,0,0,1-1.274,1.273H6.258a.635.635,0,0,0-.448.188L4.35-750.724v-1.011a.638.638,0,0,0-.634-.64H3.077A1.256,1.256,0,0,1,1.8-753.647v-3.82A1.253,1.253,0,0,1,3.077-758.736ZM13.9-757.468v1.274h1.908a1.257,1.257,0,0,1,1.273,1.274v3.82a1.257,1.257,0,0,1-1.273,1.273h-.635a.64.64,0,0,0-.453.186.64.64,0,0,0-.186.454v1.006l-1.456-1.458a.634.634,0,0,0-.451-.188H8.17a1.251,1.251,0,0,1-1.1-.634H6.784l-.743.744a2.547,2.547,0,0,0,2.13,1.163h4.191l2.36,2.358a.635.635,0,0,0,.693.137.636.636,0,0,0,.393-.586v-1.909a2.554,2.554,0,0,0,2.546-2.546v-3.82a2.556,2.556,0,0,0-2.546-2.548Z"
            transform="translate(-0.529 760.01)"
          />
        </g>
      </g>
    </svg>
  );
};

export const Location = () => {
  return (
    <svg
      t="1653299875302"
      class="icon"
      viewBox="0 0 1024 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="5987"
      width="20"
      height="20"
    >
      <path
        d="M513 535.5c-97.1 0-176-79-176-176s79-176 176-176c97.1 0 176 79 176 176s-78.9 176-176 176z m0-276c-55.2 0-100 44.9-100 100s44.9 100 100 100 100-44.9 100-100-44.8-100-100-100z"
        fill="#6f767e"
        p-id="5988"
      ></path>
      <path
        d="M512.1 1023.3c-38.6 0-75.7-16.3-101.9-44.8-50.2-54.7-127.9-152.7-195.5-264-34.1-56.2-61.2-108.5-80.3-155.5-22.8-55.9-34.4-104.3-34.4-144 0-55.6 10.9-109.6 32.4-160.4 20.8-49.1 50.5-93.1 88.3-130.9s81.9-67.5 130.9-88.3C402.4 14 456.4 3.1 512 3.1c55.6 0 109.6 10.9 160.4 32.4 49.1 20.8 93.1 50.5 130.9 88.3s67.5 81.9 88.3 130.9c21.5 50.8 32.4 104.8 32.4 160.4 0 39.7-11.6 88.1-34.4 144-19.2 46.9-46.2 99.2-80.3 155.4-67.5 111.3-145.2 209.3-195.4 264-26 28.5-63.2 44.8-101.8 44.8zM512 79.1c-185.3 0-336 150.7-336 336 0 126.2 171.6 382.9 290.2 512.1 11.9 13 28.2 20.2 45.9 20.2s33.9-7.2 45.9-20.2C676.5 798 848 541.3 848 415.1c0-185.3-150.7-336-336-336z"
        fill="#6f767e"
        p-id="5989"
      ></path>
    </svg>
  );
};
export const Order = () => {
  return (
    <svg
      id="shopping-bag"
      xmlns="http://www.w3.org/2000/svg"
      width="16.906"
      height="19.723"
      viewBox="0 0 16.906 19.723"
    >
      <path
        id="XMLID_1124_"
        d="M12.453,2A4.231,4.231,0,0,0,8.226,6.226V7.635H4.7a.7.7,0,0,0-.7.782l1.2,10.8A2.815,2.815,0,0,0,8,21.723h8.9a2.814,2.814,0,0,0,2.8-2.507l1.2-10.8a.7.7,0,0,0-.7-.782H16.679V6.226A4.231,4.231,0,0,0,12.453,2ZM9.635,6.226a2.818,2.818,0,1,1,5.635,0V7.635H9.635Zm9.779,2.818L18.3,19.061a1.407,1.407,0,0,1-1.4,1.253H8a1.407,1.407,0,0,1-1.4-1.253L5.491,9.044H8.226v1.409a.7.7,0,1,0,0,1.409H9.635a.7.7,0,0,0,0-1.409V9.044H15.27v1.409a.7.7,0,0,0,0,1.409h1.409a.7.7,0,0,0,0-1.409V9.044Z"
        transform="translate(-4 -2)"
      />
      <path
        id="XMLID_108_"
        d="M18.076,18.154a.7.7,0,0,1,.11.99l-2.818,3.522a.7.7,0,0,1-.94.146L12.314,21.4a.7.7,0,0,1,.782-1.172l1.576,1.05,2.414-3.018A.7.7,0,0,1,18.076,18.154Z"
        transform="translate(-6.365 -6.73)"
      />
    </svg>
  );
};

export const ReviewAdd = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
    >
      <g id="Group_164198" data-name="Group 164198" transform="translate(-226)">
        <rect
          id="Rectangle_164361"
          data-name="Rectangle 164361"
          width="24"
          height="24"
          transform="translate(226)"
          fill="#fff"
          opacity="0"
        />
        <g id="favourite" transform="translate(229.482 3.5)">
          <path
            id="Path_45278"
            data-name="Path 45278"
            d="M11.594,3.36H9.921A2.6,2.6,0,0,0,5.485,1.308l-.519.519-.519-.519A2.6,2.6,0,1,0,.763,4.991L2.022,6.25a5.443,5.443,0,0,0,4.807,7.995h.813l3.547,3.3v-3.3h.4a5.442,5.442,0,1,0,0-10.885ZM1.469,2.014a1.607,1.607,0,0,1,2.271,0L4.966,3.24,6.191,2.014A1.606,1.606,0,0,1,8.462,4.285l-3.5,3.5-3.5-3.5a1.608,1.608,0,0,1,0-2.271ZM11.594,13.246h-1.4v2.005L8.035,13.246H6.829A4.445,4.445,0,0,1,2.768,7l2.2,2.2,4.2-4.2a2.6,2.6,0,0,0,.465-.632h1.96a4.443,4.443,0,1,1,0,8.887Z"
            transform="translate(0 -0.546)"
          />
          <path
            id="Path_45279"
            data-name="Path 45279"
            d="M194.949,240.147H196v1h-1.056Z"
            transform="translate(-188.462 -232.174)"
          />
          <path
            id="Path_45280"
            data-name="Path 45280"
            d="M265.014,240.147h1.056v1h-1.056Z"
            transform="translate(-256.196 -232.174)"
          />
          <path
            id="Path_45281"
            data-name="Path 45281"
            d="M335.078,240.147h1.056v1h-1.056Z"
            transform="translate(-323.929 -232.174)"
          />
        </g>
      </g>
    </svg>
  );
};

export const IDCard = () => {
  return (
    <svg
      t="1695793371618"
      class="icon"
      viewBox="0 0 1026 1024"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      p-id="5130"
      width="24"
      height="24"
    >
      <path
        d="M921.6 207.36c11.264 0 20.48 9.216 20.48 20.48v573.44c0 11.264-9.216 20.48-20.48 20.48h-819.2c-11.264 0-20.48-9.216-20.48-20.48v-573.44c0-11.264 9.216-20.48 20.48-20.48h819.2m0-81.92h-819.2c-56.32 0-102.4 46.08-102.4 102.4v573.44c0 56.32 46.08 102.4 102.4 102.4h819.2c56.32 0 102.4-46.08 102.4-102.4v-573.44c0-56.832-46.08-102.4-102.4-102.4z"
        p-id="5131"
        fill="#6f767e"
      ></path>
      <path
        d="M572.928 660.48c-12.288-66.56-56.32-122.368-115.2-150.528 14.336-18.944 23.04-42.496 23.04-68.096 0-61.952-50.176-112.128-111.616-112.128s-111.616 50.176-111.616 112.128c0 25.6 8.704 49.152 23.04 68.096-60.416 28.672-103.936 83.968-116.224 150.528-3.584 19.968 11.264 37.888 31.232 37.888 7.68 0 14.848-2.56 20.48-7.68 5.632-4.608 9.728-11.264 10.752-18.944 12.288-67.072 71.168-117.76 141.312-117.76 70.144 0 129.024 51.2 141.312 117.76 2.56 15.36 15.872 26.112 31.232 26.112 17.92 0 31.744-14.848 31.744-32.256 1.024-1.024 1.024-3.072 0.512-5.12zM320.512 442.368c0-26.624 21.504-48.128 48.128-48.128s48.128 21.504 48.128 48.128-21.504 48.128-48.128 48.128-48.128-21.504-48.128-48.128zM819.2 401.92h-204.8c-22.528 0-40.96-18.432-40.96-40.96s18.432-40.96 40.96-40.96h204.8c22.528 0 40.96 18.432 40.96 40.96s-18.432 40.96-40.96 40.96zM819.2 555.52h-163.84c-22.528 0-40.96-18.432-40.96-40.96s18.432-40.96 40.96-40.96h163.84c22.528 0 40.96 18.432 40.96 40.96s-18.432 40.96-40.96 40.96zM819.2 709.12h-122.88c-22.528 0-40.96-18.432-40.96-40.96s18.432-40.96 40.96-40.96h122.88c22.528 0 40.96 18.432 40.96 40.96s-18.432 40.96-40.96 40.96z"
        p-id="5132"
        fill="#6f767e"
      ></path>
    </svg>
  );
};
